import $ from 'jquery'

const observeList = []

let tickStampStart = 0
let tickStampNow = 0
let tickStampDiff = 0
const tickInterval = 100
const tickEnd = 2 // delay
const tickBackEnd = 5 // delay
let tickCounter = 0
let tickBackCounter = 0
let ticker = false
let tickerback = false
let ticking = false
let tickingBack = false

export function addAnimation (selector, state, callback) {
	let ani = [selector, state, callback]
	$(selector).addClass(state)
	observeList.push(ani)
}

export function updateAnimation (i, selector, state, callback) {
	observeList[i] = [selector, state, callback]
}

export function observeAnimations () {
	let animation
	// if (!$('body').hasClass('single-wiki')) {
	if (observeList.length > 0) {
//		//console.log(observeList);
		for (let i = 0, len = observeList.length; i < len; i++) {

			let observeListObject = observeList[i]
//			//console.log(observeListObject);
			if (observeListObject !== null) {
				let element = document.querySelector(observeListObject[0])
//				//console.log(element)

				if (element !== null) {
					element.addEventListener('transitionend', function (e) {

						// UPDATE ON TRANSITION
						tickStampNow = Date.now()
						if (observeList[i][1] === 'idle' && !ticking) {
							tickStampStart = Date.now()
							updateAnimation(i, observeList[i][0], 'animating', observeList[i][2])
						}
						tickStampDiff = tickStampNow - tickStampStart

						// START TICKING
						// //console.log(observeList);
						if (observeList[i][1] !== 'idle' && !ticking) {
							ticking = true
							ticker = setInterval(function () {
								if (ticking) {
									if (tickCounter < tickEnd) {
										tickCounter += 1
									} else {
										// RESET tickCounter
										tickCounter = 0
										if (!tickingBack) {
											tickingBack = true
											tickerback = setInterval(function () {
												if (tickBackCounter < tickBackEnd) {
													tickBackCounter += 1
												} else {
													// RESET
													tickBackCounter = 0

													// STOP TICKING
													ticking = false
													tickingBack = false

													// CLEAR INTERVALS
													clearInterval(ticker)
													clearInterval(tickerback)

													// DONE
													observeList[i][1] = 'done'
													// //console.log('animation finished');

													updateAnimation(i, observeList[i][0], 'idle', observeList[i][2])
													tickStampNow = 0
													tickStampStart = 0

													callbackAnimation(i)
												}
											}, tickInterval)
										}
									}
								}
							}, tickInterval)
						}
					})
				}
			}

		}
	}
}

function callbackAnimation (i) {
	$(document).trigger(observeList[i][2], observeList[i])
}
